import styled from 'styled-components';

export const UserName = styled.span`
  line-height: ${({ theme }) => theme.lineHeights.sm};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.white};
  margin-right: ${({ theme }) => theme.spacings.md};
`;
